const BaseComponent = require('base/base-component');
const Spinner = require('helper/spin');
const Query = require('helper/query');
const ESClient = require('helper/es-client');

const listTpl = Handlebars.templates['university/category/templates/listTpl'];
const detailTpl = Handlebars.templates['university/category/templates/detailTpl'];
const searchlTpl = Handlebars.templates['university/category/templates/searchTpl'];
class secondaryPage extends BaseComponent {
  constructor () {
    super({
      events: {
        'change .page-size': 'changPageSize',
        'keydown .h-search #keyword': 'searchEvent',
        'click .h-search #search': 'searchEvent',
        'input .h-search #keyword': 'shapeShow',
        'click .h-search .icon-Shape': 'emptySearchInp'
      }
    });
  }
  init () {
    this.query = new Query();
    this.isFromPreview = location.hostname.indexOf('zxtmp') >= 0 || location.hostname.indexOf('cms') >= 0 || this.query.get('PID');
    if (this.isFromPreview) {
      // 后台预览时禁用点击
      document.body.addEventListener('click', (e) => {
        e.preventDefault();
        return false;
      }, true);
    }
    this.pageSize = 15;
    this.current = this.$el
      .find('.list-nav-title')
      .text()
      .trim();
    this.pageNo = 1;
    this.$bread = this.$el.find('.list-bread');
    this.$nav = this.$el.find('.list-nav');
    this.$container = this.$el.find('.list-container');
    this.$content = this.$el.find('.list-content');
    // this.$pageDom = this.$el.find('.pagination-container');
    this.$pageSizeSel = this.$el.find('.pagination-container .page-size');
    $(window).on('scroll', () => this.floatingMenu());
    this.client = new ESClient();
    this.initTree();
    this.initQRCode();
  }
  initQRCode () {
    const type = document.createElement('canvas').getContext ? 'canvas' : 'table';
    const siteId = $('input[name=siteId]').val();
    const appUrl = window.location.origin+"/app/category/index.html?id="+siteId;
    console.log('appUrl', appUrl);
    this.$el.find('.qr-show .qr-code').qrcode({
      render: `${type}`,
      width: 100,
      height: 100,
      text: appUrl,
    });
  }
  initTree () {
    let that = this;
    let mid = that.query.get('mid');
    const treeData = JSON.parse($('span.treeData').text())._DATA_;
    let param = (treeData.children && treeData.children.length > 0) ? treeData.children : [treeData];
    that.initTreeSelected(param, mid);
    /**
     * 菜单
     */
    that.$nav
      .find('.list-nav-content')
      .jstree({
        plugins: ['conditionalselect', 'wholerow'],
        conditionalselect (node) {
          if (that.isFromPreview) {
            return false;
          }
          return true;
          // return node.children.length === 0;
        },
        core: {
          data: param,
          animation: 300
        }
      })
      .on('ready.jstree', (e, data) => {
        let name = '';
        let code = '';
        let showContent = false;
        if (data.instance.get_selected().length > 0) {
          let selectData = data.instance.get_node(data.instance.get_selected()[0]).original;
          let text = selectData.text;
          // that.pageSize = selectData.pageSize || 15;
          name = selectData.name ? selectData.name : '';
          code = selectData.code ? selectData.code : '';
          showContent = selectData.showContent ? selectData.showContent : false;
          that.$content.find('.list-title-text').text(text);
          let navtext = that.getNavText(
            data.instance,
            data.instance.get_node(data.instance.get_selected()[0]).parents
          );
          that.$bread.find('#nav').text(navtext);
        }
        // 是否显示搜索框
        if (showContent) {
          that.$bread.find('.h-search-layout').html('');
        } else {
          that.$bread.find('.h-search-layout').html(searchlTpl());
        }
        // initialize content
        that.search(true, name, code);
      })
      .on('before_open.jstree', (event, data) => {
        /**
         * 闭合同级节点
         */
        let arr = null;
        if (data.node.parents.length == 1) {
          arr = data.instance.get_node(data.node.parent).children.slice();
          arr.splice(arr.indexOf(data.node.id), 1);
          for (let i = 0, len = arr.length; i < len; i++) {
            let itemNode = data.instance.get_node(arr[i]);
            if (
              data.instance.is_parent(itemNode) &&
              data.instance.is_open(itemNode)
            ) {
              data.instance.close_node(itemNode, 200);
            }
          }
        }
      })
      .on('select_node.jstree', (event, data) => {
        const url = data.instance.get_node(data.instance.get_selected()[0]).original.url;
        location.href = url;
      });
  }

  changPageSize (e) {
    this.pageSize = $(e.target).val();
    this.pageNo = 1;
    this.search(true);
  }

  /**
   * 初始化分页
   * @param count 总条数
   */
  initPagination (count) {
    let that = this;
    let sources = (function () {
      let result = [];
      for (let i = 0; i < count; i++) {
        result.push(i);
      }
      return result;
    })();
    let options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: that.pageSize,
      pageNumber: that.pageNo,
      prevText: '<',
      nextText: '>',
      showGoInput: true,
      showGoButton: true,
      beforeGoButtonOnClick: (event, pageNumber) => {
        let lastPageNo = $('.paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $('.J-paginationjs-page:last').data('num');
        }
        if (pageNumber > lastPageNo) {
          alert('跳转页数不得大于最大页数');
          return;
        }
        if (pageNumber >= 1) {
          that.pageNo = pageNumber;
          that.search(true);
        }
      },
      beforeGoInputOnEnter: (event, pageNumber) => {
        let lastPageNo = $('.paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $('.J-paginationjs-page:last').data('num');
        }
        if (!/^\d+$/.test(pageNumber) || pageNumber > lastPageNo || pageNumber < 1) {
          alert('跳转页数不合法');
          return;
        }
        that.pageNo = pageNumber;
        that.search(true);
      },
      beforePageOnClick: (event, pageNumber) => {
        that.pageNo = pageNumber;
        that.search(true);
      },
      beforePreviousOnClick: () => {
        that.pageNo--;
        that.search(true);
      },
      beforeNextOnClick: () => {
        that.pageNo++;
        that.search(true);
      }
    };
    // that.$pageDom.find('.pagination-list').pagination(options);
    that.$el.find('.content-list .pagination-list').pagination(options);
  }

  searchEvent (e) {
    if (e.type === 'keydown' && e.keyCode == 13) {
      this.$content.find('.list-title-text').text('搜索结果');
      this.pageNo = 1;
      this.search(true);
    } else if (e.type === 'click') {
      this.pageNo = 1;
      this.$content.find('.list-title-text').text('搜索结果');
      this.search(true);
    }
  }

  search (isRefresh, name, code) {
    let that = this;
    let spinner = null;
    let tree = that.$nav.find('.list-nav-content').jstree(true);
    let showContent = tree.get_node(tree.get_selected()).original.showContent;
    if (!name) {
      name = tree.get_node(tree.get_selected()).original.name;
      code = tree.get_node(tree.get_selected()).original.code;
    }

    const articleId = this.query.get('articleId');
    const PID = this.query.get('PID');

    // 预览的时候es里还没有建立此文章的索引，所以需要通过restful接口去查
    if (showContent && PID && articleId) {
      $.ajax({
        type: 'GET',
        url: '/article/detail',
        contentType: 'application/json',
        data: {
          categoryCode: code,
          articleId,
          PID
        },
        beforeSend () {
          spinner = new Spinner({ top: '45%' }).spin(
            $('.content-list')[0]
          );
        }
      })
        .done((resp) => {
          that.$content.find('.content-list').html(detailTpl);
          that.initializeIframe(resp.content);
        })
        .always(() => {
          spinner.stop();
        });
      return;
    }

    const requestData = {
      // hardcord 高校siteId=11
      siteId: 11,
      pageNo: that.pageNo,
      pageSize: that.pageSize,
      code
    };

    let $searchInp = that.$bread.find('#keyword');
    if ($searchInp.length > 0 && $searchInp.val()) {
      requestData.keyword = $searchInp.val();
    }

    spinner = new Spinner({ top: '45%' }).spin(
      $('.content-list')[0]
    );
    if (showContent) {
      $.ajax({
        type: 'GET',
        url: '/show/content?categoryCode=' + code,
        contentType: 'application/json',
        beforeSend () {
          spinner = new Spinner({ top: '45%' }).spin(
            $('.content-list')[0]
          );
        }
      })
        .done((resp) => {
          if (resp) {
            that.$content.find('.content-list').html(detailTpl);
            this.initializeIframe(resp);
          } else {
            that.$content.find('.content-list').html('<p class="noData">暂无数据</p>');
          }
        })
        .always(() => {
          // spinner.stop();
        });
    } else {
      this.client
        .searchArticleByKeyWord(requestData)
        .done((resp) => {
          const total = resp.hits.total;
          that.$content.find('.content-list').html(listTpl({ _DATA_: resp.hits, _pageSize_: that.pageSize || '15' }));
          that.$el.find('.content-list .total').text(total);
          if (isRefresh) {
            that.initPagination(total);
          }
        })
        .fail(() => {
          that.$content.find('.content-list-container').html('<p class=\'noData\'>暂无数据</p>');
        })
        .always(() => {
          spinner.stop();
        });
    }
  }

  /**
   * 初始化tree默认选中
   * @param obj tree的data对象
   * @param mid 要选中treenode的id
   */
  initTreeSelected (obj, mid) {
    !b(obj, mid) && c(obj);
    /* eslint-disable */
    function b (o, mid) {
      for (let i = 0, len = o.length; i < len; i++) {
        let item = o[i];
        if (mid) {
          if (item.id == mid) {
            if (item.state) {
              item.state.selected = true;
            } else {
              item.state = {};
              item.state.selected = true;
            }
            return true;
          }
        } else if (item.selected) {
          if (item.state) {
            item.state.selected = true;
          } else {
            item.state = {};
            item.state.selected = true;
          }
          return true;
        }
        if (item.children && item.children.length > 0) {
          if (b(item.children, mid)) {
            return true;
          }
        }
      }
    }

    function c (o) {
      if(o instanceof Array) {
        if (o[0].children && o[0].children.length > 0) {
          c(o[0].children);
        } else if (o[0].state) {
          o[0].state.selected = true;
        } else {
          o[0].state = {};
          o[0].state.selected = true;
        }
      }else{
        if(o.state){
          o.state.selected = true;
        }else{
          o.state={};
          o.state.selected = true;
        }
      }
    }
  }

  floatingMenu () {
    let that = this;
    let _h = that.$content.height();
    let _st = $(document).scrollTop();
    // that.$container.find('.list-nav').css({"position":"fixed","top":"0"})
    let $nav = that.$container.find('.list-nav');
    if (_h > 800) {
      if (_st > 340 && _st < _h - 260) {
        $nav.css({ position: 'fixed', top: '0' });
      } else if (_st >= _h - 260) {
        $nav.css({ position: 'absolute', top: _h - 700 });
      } else {
        $nav.css({ position: 'absolute', top: '0' });
      }
    } else {
      $nav.css({ position: 'absolute', top: '0' });
    }
  }

  getNavText (instance, list) {
    let arr = [];
    for (let i = 0, len = list.length - 1; i < len; i++) {
      arr.unshift(instance.get_node(list[i]).original.text);
    }
    arr.push(instance.get_node(instance.get_selected()[0]).original.text);
    return arr.join(' > ');
  }

  shapeShow (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.h-search .icon-Shape').show();
    } else {
      this.$el.find('.h-search .icon-Shape').hide();
    }
  }

  emptySearchInp (e) {
    let $searchInp = this.$bread.find('#keyword')
    $searchInp.val('');
    $(e.target).hide();
    this.pageNo = 1;
    this.search(true);
  }

  initializeIframe (articleDetail) {
    const $iframe = $('#article-content');
    $iframe.on('load', () => this.resizeIframe());
    const buildTemplate = (content = '') => `
      <!DOCTYPE html>
      <html xmlns='http://www.w3.org/1999/xhtml' class='view'>
      <head>
        <style type='text/css'>.view{padding:0;word-wrap:break-word;cursor:text;height:90%;}body{margin:8px;font-family:sans-serif;font-size:16px;}p{margin:5px 0;}
        </style>
        <style id="table">.selectTdClass{background-color:#edf5fa !important}table.noBorderTable td,table.noBorderTable th,table.noBorderTable caption{border:1px dashed #ddd !important}table{margin-bottom:10px;border-collapse:collapse;display:table;}td,th{padding: 5px 10px;border: 1px solid #DDD;}caption{border:1px dashed #DDD;border-bottom:0;padding:3px;text-align:center;}th{border-top:1px solid #BBB;background-color:#F7F7F7;}table tr.firstRow th{border-top-width:2px;}.ue-table-interlace-color-single{ background-color: #fcfcfc; } .ue-table-interlace-color-double{ background-color: #f7faff; }td p{margin:0;padding:0;}</style>
        <style id="list">ol,ul{margin:0;pading:0;width:95%}li{clear:both;}.list-paddingleft-1{padding-left:0}.list-paddingleft-2{padding-left:30px}.list-paddingleft-3{padding-left:60px}</style>
        <style id="pre">pre{margin:.5em 0;padding:.4em .6em;border-radius:8px;background:#f8f8f8;}</style>
        <style>.fjxx{box-sizing: border-box;}</style>
        <style>.template-law{font-size:14px;}.law-info{width:100%;background:#f9f9f9;border:1px solid #eee;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-info > tbody > tr > td{padding:5px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100px;}.law-info > tbody > tr > td p{max-width:190px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}.law-info .text-right{text-align:right;}.law-info .info_title{height:32px;font-size:16px;color:#f00;font-weight:bold;text-align:center;}.law-info td,th{border:0;}.law-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-title h1{width:100%;text-align:center;font-size:40px;color:#f00;text-decoration:none;font-weight:bold;margin-bottom:60px;margin:0;padding:120px 0 60px 0;}.law-title h2{border-bottom:#f00 solid 3px;line-height:50px;font-size:17px;color:#000;text-decoration:none;font-weight:normal;height:50px;width:100%;text-align:center;padding:0;margin:0 0 40px 0;}.law-title p{font-size: 20px;padding-bottom:15px;}</style>
      </head>
      <body class='view'>${content}</body>
      </html>`;
    const doc = $iframe[0].contentDocument;
    const content = articleDetail.replace(/contenteditable="true"/g, '')
      .replace(/<section/g, '<div')
      .replace(/<\/section>/g, '</div>');
    if (typeof articleDetail === 'string') {
      doc.open();
      doc.write(buildTemplate(content));
      doc.close();
    } else {
      doc.open();
      doc.write('<div id="iframe-root"></div>');
      doc.close();
    }
  }

  resizeIframe () {
    const $iframe = $('#article-content');
    const iframeBodyHeight = $iframe[0].contentDocument.body.scrollHeight;
    $iframe.height((iframeBodyHeight + 20) + 'px');
  }
}
module.exports = secondaryPage;
